import { api } from '../../core/api.js';
import { register } from '../../core/events.js';
import { html } from '../../core/html.js';
import { fmtDate, inr } from '../../core/format.js';
import { reload } from '../../app/shell.js';
import { empty, ic, statusTag, table, tag } from '../../ui/components.js';
import { payManually } from '../billing/pay.js';
import { confirmBox } from '../../ui/modal.js';
import { toast } from '../../ui/toast.js';

function orderStatus(o) {
  if (o.manual && o.status === 'created') return o.payment_reference ? tag('Awaiting confirmation', 'wn') : tag('Not paid yet', 'n');
  return statusTag(o.status);
}

function orderAction(o) {
  return o.manual && o.status === 'created' && !o.payment_reference
    ? html`<button type="button" class="btn soft sm" data-act="order.pay" data-id="${o.id}">Complete payment</button>`
    : '';
}

const billing = {
  path: '/student/billing',
  roles: ['student'],
  title: 'Billing',
  async load(ctx) {
    const [orders, invoices, mine] = await Promise.all([
      api.get('/billing/orders', { signal: ctx.signal }),
      api.get('/billing/invoices', { signal: ctx.signal }),
      api.get('/me/enrollments', { signal: ctx.signal }),
    ]);
    shownOrders = orders.orders;
    return { orders: orders.orders, invoices: invoices.invoices, enrollments: mine.enrollments };
  },
  view(d) {
    const subs = d.enrollments.filter((e) => e.current_period_end);
    return html`<h3>Subscriptions</h3>
      ${subs.length
        ? table(['Course', 'Status', 'Access until', ''], subs.map((e) => [e.course.title, e.cancelled ? statusTag('cancelled') : statusTag(e.has_access ? 'active' : 'expired'), fmtDate(e.current_period_end),
          e.cancelled || !e.has_access ? html`<a class="btn ghost sm" href="/student/course/${e.course.slug}">${e.has_access ? 'View' : 'Renew'}</a>` : html`<button type="button" class="btn ghost sm" data-act="sub.cancel" data-id="${e.id}">Cancel</button>`]))
        : empty('wallet', 'No subscriptions', 'When you join a batch it shows up here.')}
      <h3 class="mt">Invoices</h3>
      ${table(['Invoice', 'Date', 'Description', 'Total', ''], d.invoices.map((i) => [html`<span class="mono">${i.number}</span>`, fmtDate(i.issued_at), i.description, inr(i.total_paise),
        html`<button type="button" class="btn soft sm" data-act="invoice.print" data-number="${i.number}">${ic('dl')} Open</button>`]), { empty: 'No invoices yet.' })}
      <h3 class="mt">Payments</h3>
      ${table(['Order', 'Course', 'Date', 'Amount', 'Status', ''], d.orders.map((o) => [`#${o.id}`, o.course_title || (o.kind === 'resume' ? 'Resume help' : o.kind === 'deposit' ? 'Verification deposit' : ''), fmtDate(o.created_at), inr(o.total_paise), orderStatus(o), orderAction(o)]), { empty: 'No payments yet.' })}
      <p class="note mt-s">Refunds and billing questions: write to us from the Contact page and quote the order number.</p>`;
  },
};

let shownOrders = [];

register({
  'order.pay': async (el) => {
    const order = shownOrders.find((o) => String(o.id) === el.dataset.id);
    if (!order) return;
    const result = await payManually(order);
    if (result.status === 'pending') await reload();
  },
  'sub.cancel': async (el) => {
    const sure = await confirmBox({ title: 'Cancel this subscription?', text: 'You keep access until the end of the period you already paid for. No further payments will be taken.', label: 'Cancel subscription', danger: true, cancel: 'Keep it' });
    if (!sure) return;
    await api.post(`/billing/subscriptions/${el.dataset.id}/cancel`);
    toast('Subscription cancelled');
    await reload();
  },
});

export const routes = [billing];
